module.exports = __webpack_public_path__ + "static/media/CainIjegunClassroomTeam.b9b07001.JPG";